<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">


  <div fxLayout="column" class="mat-typography">


    <!-- ConsumerReferral Campaigns as Tabs -->
    <div fxLayout="row" style="margin-bottom: 10px;">
      <div fxLayout="row" fxLayoutAlign="start center" class="section-title" fxLayoutGap="10px">

        <!-- TabItem -->
        @for (grp of form.controls.staffReferralCampaigns['controls']; track grp; let i = $index) {
        <div class="tab-item" [class.active]="selectedChannelIndex === i" (click)="selectedChannelIndex = i">
          {{ grp.value['title'] || ('New staff referral ' + (i + 1)) }}
        </div>
        }


        @if (form.controls.staffReferralCampaigns['controls'].length === 0) {
        <div>
          No staff referral campaigns
        </div>
        }

      </div>
      <div fxFlex></div>
      <lib-button icon="add" (buttonClick)="addStaffReferral()">Add Staff Referral campaign</lib-button>
    </div>

    <!-- Current ConsumerReferralCampaign (active tab) -->
    @for (grp of form.controls.staffReferralCampaigns['controls']; track grp; let i = $index) {
    @if (i === selectedChannelIndex) {
    <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="5px">
      <div class="box space-bottom" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <mat-form-field fxFlex>
            <mat-label>Campaign Display Name</mat-label>
            <input type="text" matInput placeholder="" [formControl]="grp['controls'].title" autocomplete="off">
            @if (grp.get('title').touched && grp.get('title').touched && !grp.get('title').valid) {
            <mat-error>Please
              enter the campaign display name</mat-error>
            }
            <mat-hint>Shown to consumers in the app.</mat-hint>
          </mat-form-field>
          <div>
            <lib-button icon="delete" (buttonClick)="removeStaffReferral(i)">Remove campaign</lib-button>

            @if (grp['controls'].id.value) {
            <lib-button icon="share" (buttonClick)="onGenerateCode(grp['controls'].id.value)">Share invite</lib-button>
            }
          </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="start space-between" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>Staff onboarding landing page URL</mat-label>
            <input matInput placeholder="" [formControl]="grp['controls'].onboardingUrl" autocomplete="off">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Campaign description</mat-label>
            <input matInput placeholder="" [formControl]="grp['controls'].description" maxlength="100" autocomplete="off">
            @if (grp.get('description').touched && !grp.get('description').valid) {
            <mat-error>Please enter a valid
              description</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Campaign unjoined description</mat-label>
            <textarea rows="6" matInput placeholder="" [formControl]="grp['controls'].detailedDescription"
              autocomplete="off"></textarea>
            @if (grp.get('detailedDescription').touched && !grp.get('detailedDescription').valid) {
            <mat-error>Please
              enter a valid unjoined description</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Campaign joined description</mat-label>
            <textarea rows="6" matInput placeholder="" [formControl]="grp['controls'].detailedDescriptionJoined"
              autocomplete="off"></textarea>
            @if (grp.get('detailedDescriptionJoined').touched && !grp.get('detailedDescriptionJoined').valid) {
            <mat-error>Please
              enter a valid joined description</mat-error>
            }
          </mat-form-field>
        </div>
        <div fxLayout="column">
          <p class="upload-image-title" [class.invalid]="false">Staff Referral Thumbnail</p>
          <div class="avatar-container thumb" (click)="fileInputThumbnailBanner.click()">
            <input class="hidden" #fileInputThumbnailBanner type="file" accept=".png, .jpg, .jpeg"
              (change)="onThumbImageSelected($event, grp['controls'].staffReferralThumbnailUrl)">
            <div class="icon-container">
              <mat-icon color="primary">photo_camera</mat-icon>
            </div>
            <div class="avatar">
              <lib-photo [url]="grp.get('staffReferralThumbnailUrl').value" [width]="'231.11px'" [height]="'130px'"
                [radius]="'10px'"></lib-photo>
            </div>
            <div class="image-info">Thumb 16:9</div>
          </div>
        </div>
        <div fxLayout="column">
          <app-staff-referral-campaign-banner #staffReferralCampaignBanner
            [staffReferralBanners]="grp.get('staffReferralBanner').value"
            (mainReferralBannerChanged)="onBannerChange($event, grp['controls'].staffReferralBanner)">
          </app-staff-referral-campaign-banner>
        </div>
        <div fxLayout="row" fxLayoutAlign="start" fxFlexFill fxLayoutGap="20px">
          <mat-slide-toggle fxFlex [formControl]="grp['controls'].shouldAdvertise" color="primary">
            <label class="form-label">Should Advertise</label>
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex [formControl]="grp['controls'].canJoin" color="primary">
            <label class="form-label">Can Join</label>
          </mat-slide-toggle>
          <mat-slide-toggle fxFlex [formControl]="grp['controls'].shouldHideParticipatingLocations" color="primary">
            <label class="form-label">Hide participating locations</label>
          </mat-slide-toggle>
          <mat-slide-toggle [formControl]="grp['controls'].isForceUsingMobileApp" fxFlex color="primary">
            <label class="form-label">Force using Mobile App</label>
          </mat-slide-toggle>
        </div>
        <!-- STAFF REWARDS -->
        <div fxFlex class="rewards-title">Staff rewards for referral</div>
        <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="10px">
          <app-reward-data-edit fxFlex [formControl]="grp['controls'].joinReward" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'Reward for joining'" [allowCoins]="true"
            [allowStamps]="false">
          </app-reward-data-edit>
          <app-reward-data-edit fxFlex [formControl]="grp['controls'].firstConsumptionReward" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'Reward for first consumption'" [allowCoins]="true"
            [allowStamps]="false">
          </app-reward-data-edit>
          <app-reward-data-edit fxFlex [formControl]="grp['controls'].anyConsumptionReward" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'Reward for any consumption'" [allowCoins]="true"
            [allowStamps]="false">
          </app-reward-data-edit>
        </div>
        <!-- <div><pre>{{ grp.value.joinReward | json }}</pre></div> -->
        <div fxFlex></div>
      </div>
    </div>
    }
    }

  </div>


  <!-- <div><pre>{{ form.value | json }}</pre></div> -->

</form>

<lib-loading-overlay [isLoading]="isLoading" [message]="'loading...'" />
